import { HttpHeaders, HttpParams } from '@angular/common/http';

export type GenericApiQuery = {
  [x: string]: any;
  key?: string;
  page?: number;
  limit?: number;
  orderBy?: string;
  orderType?: string;
};

export type GenericApiOption = {
  excludeFields?: string[];
  exposeHeaders?: { [key: string]: string | string[] };
  loader?: boolean;
  pretreatmentResponse?: boolean;
  requestOptions?: {
    headers?: HttpHeaders | { [header: string]: string | string[] };
    observe?: string | any;
    params?: HttpParams | { [param: string]: string | string[] };
    reportProgress?: boolean;
    responseType?: string | any;
    withCredentials?: boolean;
  };
};

export type GenericApiResponseMeta = {
  itemsPerPage: number;
  currentPage: number;
  totalPages: number;
  totalItems: number;
  pageSizeOptions: number[];
};

export type GenericApiResponseError = {
  statusCode: number;
  error: any;
  errorCode: any;
  message: string;
};

export type ApiResponse<T = Record<string, unknown>> = { data?: T; statusCode: number };
